import { IoSettings } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import { ICON_MAP } from '../../shared/constants/iconMap';
import { useMenu } from '../../shared/context/MenuContext';

interface MobileSidebarProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  isActive: (path: string) => boolean;
}

function MobileSidebar({ isOpen, setIsOpen, isActive }: MobileSidebarProps) {
  const { menuItems, isLoading, userType, partnerName } = useMenu();

  return (
    <>
      {/* 백드롭 오버레이 - 사이드바가 열렸을 때 메인 콘텐츠 스크롤 방지 */}
      {isOpen && (
        <div
          className='fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden'
          onClick={() => setIsOpen(false)}
          style={{ touchAction: 'none' }}
        />
      )}

      {/* 모바일용 상단 메뉴 - 위치 수정 */}
      <div className='md:hidden fixed top-0 left-0 right-0 bg-white z-20 border-b shadow-sm'>
        <div className='flex items-center justify-between p-4'>
          <button
            type='button'
            onClick={() => setIsOpen(!isOpen)}
            className='p-2 rounded-lg hover:bg-gray-100 transition-colors'
          >
            {isOpen ? '◀' : '▶'}
          </button>
          <div className='flex-1 text-center'>
            <h2 className='font-bold text-lg text-punta-orange'>
              {userType === 'partner' ? '파트너사 어드민' : '식후경 어드민'}
            </h2>
          </div>
          <div className='w-10' /> {/* 우측 균형을 위한 빈 공간 */}
        </div>
      </div>

      {/* 사이드바 */}
      <div
        className={`
    fixed top-0 left-0 h-full bg-white shadow-lg
    transition-transform duration-300 ease-in-out
    md:hidden
    ${isOpen ? 'translate-x-0' : '-translate-x-full'}
    w-64
    z-50
    overflow-hidden
    flex flex-col
  `}
      >
        <div className='p-4 border-b flex justify-between items-center mt-16 flex-shrink-0'>
          <div>
            <h2 className='font-bold text-xl text-punta-orange'>
              {userType === 'partner' ? '파트너사 어드민' : '관리자'}
            </h2>
            {userType === 'partner' && partnerName && (
              <div className='text-sm text-orange-600 mt-1'>{partnerName}</div>
            )}
          </div>
          <button
            type='button'
            onClick={() => setIsOpen(false)}
            className='p-2 rounded-lg hover:bg-gray-100'
          >
            ✕
          </button>
        </div>

        <div className='flex-1 flex flex-col min-h-0'>
          {isLoading ? (
            <div className='p-4 text-center text-gray-500'>메뉴 로딩 중...</div>
          ) : (
            <div
              className='flex-1 overflow-y-auto touch-pan-y mobile-sidebar-scroll'
              style={{ WebkitOverflowScrolling: 'touch' }}
            >
              <nav className='mt-4'>
                {menuItems.map((item: any) => (
                  <Link
                    key={item.id}
                    to={item.path}
                    className={`
              flex items-center p-3 text-gray-700 hover:bg-orange-50
              transition-all duration-200 relative group
              ${isActive(item.path) && 'bg-orange-50 text-punta-orange'}
            `}
                    onClick={() => setIsOpen(false)}
                  >
                    <div className='flex items-center'>
                      {/* 아이콘 매핑 적용 */}
                      {ICON_MAP[item.icon] || (
                        <IoSettings className='w-5 h-5' />
                      )}
                      <span className='ml-3 text-sm'>{item.title}</span>
                    </div>
                  </Link>
                ))}
              </nav>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default MobileSidebar;
